import React from 'react';
import {Drawer, DrawerTitleProps} from '@mantine/core';

export const EtroDrawerTitle: React.FC<DrawerTitleProps> = props => {
  return <Drawer.Title {...props} />;
};
